import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faExclamationCircle, faGift, faEngineWarning, faSignOutAlt } from '@fortawesome/pro-solid-svg-icons';

import AppModule from './containers/AppModule/AppModule';
import { configApiService } from './services/api.service';

const baseUrl = window.APP_CONFIG.apiHost || process.env.REACT_APP_API_HOST;
configApiService(baseUrl, { withCredentials: true });

library.add(faCheck, faExclamationCircle, faGift, faEngineWarning, faSignOutAlt);

const render = () => {
  ReactDOM.render(<AppModule />, document.getElementById('root'));
};

render();

if (module.hot) {
  module.hot.accept('./containers/AppModule/AppModule', () => {
    render();
  });
}
